import { fetchUserOrders, updateAuthToken } from "ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { urlParam, gotoUrl, pathWithChannel, isWebView } from "utils/helpers";
import { makeSelectPlanTextName } from "ducks/selectors";
import { paths, publicPaths } from "utils/constants";
import {
  getAndRemoveItem,
  APP_REDIRECT_PATH,
  isAUAccount
} from "utils/localStorage";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import includes from "lodash/includes";
import get from "lodash/get";

const useFetchOrdersAndRedirect = redirectChannel => {
  const redirect = urlParam("redirect");
  const urlAuthToken = urlParam("auth_token");
  const dispatch = useDispatch();

  const hasVisitedPreCheckoutPage = !!useSelector(makeSelectPlanTextName());

  const fetchOrdersAndRedirect = (channel, redirectPath, userDetails) => {
    const isTelcoUser = get(userDetails, "telco_user");

    dispatch(
      fetchUserOrders({}, (userOrders, errors) => {
        const orders = filter(
          userOrders,
          order => !includes(["IC", "TER", "CAN"], order.state)
        );
        const reload = isWebView();
        if (errors) {
          // If errors invalidate the token and redirect to login page
          dispatch(updateAuthToken(null, null));
          return gotoUrl(pathWithChannel(publicPaths.LOGIN_PAGE, channel));
        }

        const redirectFromSocialLogin = getAndRemoveItem(APP_REDIRECT_PATH);
        if (redirectFromSocialLogin)
          return gotoUrl(redirectFromSocialLogin, false, {}, reload);
        if (redirect) return gotoUrl(redirect, false, {}, reload);

        // we are clearing the auth_token param to load manage/update-card page.
        if (redirectPath)
          return gotoUrl(redirectPath, true, { auth_token: null });

        //if user is logging in webview without auth_token in url, then user redirect to weblogin
        if (isWebView() && !urlAuthToken && isTelcoUser && !isAUAccount()) {
          return gotoUrl(paths.DASHBOARD, false, {}, reload);
        }

        if (!isEmpty(orders)) {
          return gotoUrl(paths.MANAGE_ORDER, false, {}, reload);
        }

        const nextRoute = hasVisitedPreCheckoutPage
          ? paths.CONNECTION_DETAILS
          : paths.PRE_CHECKOUT;
        return gotoUrl(
          pathWithChannel(nextRoute, redirectChannel),
          false,
          {},
          reload
        );
      })
    );
  };

  return fetchOrdersAndRedirect;
};

export default useFetchOrdersAndRedirect;
